import React from 'react';
import PropTypes from 'prop-types';
import {
  Tooltip, TooltipProvider,
} from '@usealloy/component-library';

const TagSquarePropTypes = {
  id: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  tooltipText: PropTypes.string,
  color: PropTypes.string,
  customClasses: PropTypes.string,
};
const TagSquareDefaultPropTypes = {
  dataTestId: null,
  tooltipText: null,
  color: 'CCCCC4',
  customClasses: 'fas fa-fw fa-lg',
};

const TagSquare = ({
  id, dataTestId, tooltipText, color, customClasses,
}) => {
  let squareColor = color;
  if (color?.includes('#')) {
    squareColor = color.replace(/#/g, '');
  }
  if (tooltipText && id) {
    return (
      <TooltipProvider>
        <Tooltip
          content={tooltipText}
          align="end"
          side="top"
        >
          <span>
            {/* TODO: replace <i> with component library once icon exists */}
            <i
              id={id}
              data-testid={dataTestId}
              className={`fa-square ${customClasses}`}
              style={{ color: `#${squareColor}` }}
            />
          </span>
        </Tooltip>
      </TooltipProvider>
    );
  }
  return (
    <span>
      {/* TODO: replace <i> with component library once icon exists */}
      <i
        data-testid={dataTestId}
        className={`fa-square ${customClasses}`}
        style={{ color: `#${squareColor}` }}
      />
    </span>
  );
};

TagSquare.propTypes = TagSquarePropTypes;
TagSquare.defaultProps = TagSquareDefaultPropTypes;

export default TagSquare;
